import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { getFormAsyncErrors, reset, submit } from 'redux-form'
import { clearFiltersDrawer } from '../../../../actions/bookingCalendar/filtering/applyFiltersDrawer'
import {
  IDrawerActions,
  IDrawerDispatch,
  IDrawerFormProps,
  IDrawerProps,
} from './Drawer'
import { Mixpanel } from '../../../../utils/Mixpanel'

function mapStateToProps() {
  const form = getFormAsyncErrors('filterRooms')

  return (state): IDrawerFormProps => ({
    formErrors: form(state) as any,
  })
}

function bindDispatchToProps(dispatch: Dispatch): IDrawerDispatch {
  return {
    clearChanges() {
      Mixpanel.track('Calendar Filter Cleared', {})
      dispatch(reset('filterRooms'))
      dispatch(clearFiltersDrawer())
    },
    submitChanges() {
      dispatch(submit('filterRooms'))
    },
  }
}

export default connect<
  IDrawerFormProps,
  IDrawerDispatch,
  IDrawerActions & IDrawerProps
>(
  mapStateToProps(),
  bindDispatchToProps,
)
